/* ==================================================================
   GOOD-NATURED WARENKORB (Schublade) - 12.10.2026
   ==================================================================
   Zwei Aufgaben, beide ohne den Warenkorb selbst umzubauen - das
   Markup kommt fertig aus Liquid (snippets/cart-drawer.liquid):

   1) Ziel-Balken animieren
      Bei jeder Aenderung tauscht das Theme den Inhalt der Schublade
      komplett aus. Der neue Balken kaeme dann ohne Bewegung einfach
      im neuen Stand. Das Skript merkt sich den letzten Stand, setzt
      den frischen Balken kurz darauf zurueck und laesst ihn dann in
      den neuen Stand laufen. Wird 85 EUR ueberschritten, laeuft der
      Uebergang in drei Schritten (Klasse gn-ziele--erweitert).

   2) "Passt zu deinem Taste": Groesse waehlen und hinzufuegen
      Das Formular jeder Karte geht an /cart/add und bittet Shopify
      gleich um den neu gerechneten Warenkorb (sections). Den reicht
      es an renderContents() der Schublade aus assets/cart-drawer.js
      weiter - derselbe Weg, den der Kaufbutton auf der Produktseite
      nimmt. Ohne gewaehlte Groesse wackelt das Groessenfeld kurz.
   ================================================================== */
(function () {
  if (window.gnWarenkorb) return;
  window.gnWarenkorb = true;

  /* ---------------- 1) Ziel-Balken ---------------- */
  var letzter = null;
  var werte = ['--gn-s1', '--gn-f1', '--gn-f2', '--gn-luecke', '--gn-g'];

  function lesen(el) {
    var w = { stufe: parseInt(el.getAttribute('data-stufe'), 10) };
    werte.forEach(function (k) { w[k] = el.style.getPropertyValue(k); });
    return w;
  }

  function setzen(el, w) {
    werte.forEach(function (k) { el.style.setProperty(k, w[k]); });
  }

  function vorbereiten(el) {
    if (el.getAttribute('data-gn-bereit')) return;
    el.setAttribute('data-gn-bereit', '1');
    var ziel = lesen(el);
    var vorher = letzter;
    letzter = ziel;
    if (!vorher) return;
    el.classList.add('gn-ziele--ohne-animation');
    setzen(el, vorher);
    void el.offsetWidth;
    el.classList.remove('gn-ziele--ohne-animation');
    if (vorher.stufe === 1 && ziel.stufe > 1) el.classList.add('gn-ziele--erweitert');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { setzen(el, ziel); });
    });
  }

  function suchen() {
    document.querySelectorAll('.gn-ziele').forEach(vorbereiten);
  }

  suchen();
  new MutationObserver(suchen).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- 2) Empfehlungen ---------------- */
  /* Die Empfehlungen liegen in <cart-drawer-items>. Das Theme (cart.js)
     hoert dort auf JEDE Aenderung und haelt sie fuer eine geaenderte
     Menge - die Groessenwahl loeste deshalb "Beim Aktualisieren deines
     Warenkorbs ist ein Fehler aufgetreten" aus. Deshalb wird die
     Aenderung am Groessenfeld schon auf dem Weg nach unten (capture)
     angehalten und erreicht cart.js gar nicht erst. */
  document.addEventListener('change', function (event) {
    var feld = event.target.closest ? event.target.closest('.gn-wk-karte select') : null;
    if (!feld) return;
    event.stopPropagation();
    feld.closest('.gn-wk-karte').classList.remove('gn-wk-karte--fehlt');
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('form[data-gn-karte]') : null;
    if (!form) return;
    event.preventDefault();

    var karte = form.closest('.gn-wk-karte');
    var feld = form.querySelector('[name="id"]');
    var knopf = form.querySelector('button[type="submit"]');
    var meldung = karte.querySelector('.gn-wk-karte__meldung');

    if (!feld || !feld.value) {
      karte.classList.remove('gn-wk-karte--fehlt');
      void karte.offsetWidth;
      karte.classList.add('gn-wk-karte--fehlt');
      if (feld && feld.focus) feld.focus();
      return;
    }

    if (karte.classList.contains('gn-wk-karte--laedt')) return;
    karte.classList.add('gn-wk-karte--laedt');
    knopf.setAttribute('aria-busy', 'true');
    if (meldung) meldung.textContent = '';

    var adresse = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(adresse, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(feld.value, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (antwort) { return antwort.json(); })
      .then(function (stand) {
        if (stand.status) {
          if (meldung) meldung.textContent = stand.description || stand.message || form.getAttribute('data-fehler');
          return;
        }
        var schublade = document.querySelector('cart-drawer');
        if (schublade && typeof schublade.renderContents === 'function' && stand.sections) {
          schublade.renderContents(stand);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (meldung) meldung.textContent = form.getAttribute('data-fehler');
      })
      .finally(function () {
        karte.classList.remove('gn-wk-karte--laedt');
        knopf.removeAttribute('aria-busy');
      });
  });
})();
